/* Water Breaks the Rules lead magnet page. Flip cards + sticky mobile CTA. Built 2026-09-15 v2. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Flip cards: accessible buttons, work by click and keyboard (native button behaviour).
    document.querySelectorAll('[data-flip-card]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    // Sticky mobile CTA: shown once the hero form and the lower form are both out of view.
    var bar = document.querySelector('[data-booklet-sticky]');
    var heroForm = document.getElementById('booklet-hero-form');
    var lowerForm = document.getElementById('booklet-form');
    if (bar && 'IntersectionObserver' in window && (heroForm || lowerForm)) {
      var heroVisible = !heroForm;
      var lowerVisible = !lowerForm;
      var update = function () {
        if (heroVisible || lowerVisible) bar.setAttribute('hidden', '');
        else bar.removeAttribute('hidden');
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === heroForm) heroVisible = entry.isIntersecting;
          if (entry.target === lowerForm) lowerVisible = entry.isIntersecting;
        });
        update();
      }, { threshold: 0.1 });
      if (heroForm) io.observe(heroForm);
      if (lowerForm) io.observe(lowerForm);
      update();
    }
  });
})();
